import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { imgUrl } from "@/lib/api";
import { SectionTitle, Reveal } from "./Decor";

export const GallerySection = ({ c, s }) => {
  const items = (c?.gallery || []).filter((g) => g.image);
  const [open, setOpen] = useState(null);
  return (
    <section id="gallery" className="bg-white py-16 sm:py-20" data-testid="gallery-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <SectionTitle id="gallery" title={s.title} subtitle={s.subtitle} />
        <div className="columns-1 gap-4 min-[420px]:columns-2 md:columns-3">
          {items.map((g, i) => (
            <Reveal key={g.id || i} delay={(i % 3) * 0.08} className="mb-4 break-inside-avoid">
              <button onClick={() => setOpen(g)} data-testid={`gallery-item-${i}`} className="group block w-full overflow-hidden rounded-3xl bg-sky-50 text-left ring-1 ring-sky-100">
                <div className="overflow-hidden">
                  <img src={imgUrl(g.image)} alt={g.caption || "Gallery photo"} loading="lazy" className="w-full transition-transform duration-500 group-hover:scale-[1.04]" />
                </div>
                {g.caption && <p className="px-4 py-3 text-sm font-medium text-slate-700">{g.caption}</p>}
              </button>
            </Reveal>
          ))}
        </div>
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-3xl border-0 bg-white p-3 sm:rounded-3xl" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{open?.caption || "Photo"}</DialogTitle>
          {open && <img src={imgUrl(open.image)} alt={open.caption} className="max-h-[78vh] w-full rounded-2xl object-contain" />}
          {open?.caption && <p className="px-2 pb-1 text-center text-sm font-medium text-slate-700">{open.caption}</p>}
        </DialogContent>
      </Dialog>
    </section>
  );
};
